/*
This file gathers references to all the SVGs in the store,
then passes them to Webpack to build into svg-store.js.
*/
const files = import.meta.webpackContext('./', {
  recursive: false,
  regExp: /\.svg$/,
});
files.keys().forEach(files);
